// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&family=Lora:ital,wght@0,400;0,600;1,400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ======================================
   DESIGN TOKENS — Pyate Blue Brand
   Matched to: white navbar, #F0F2F5 page bg,
   #1565C0 primary blue accents
====================================== */
:root {
  --brand:          #1565C0;
  --brand-mid:      #1976D2;
  --brand-light:    #42A5F5;
  --brand-soft:     #E8F1FB;
  --brand-glow:     rgba(21, 101, 192, 0.15);
  --brand-glow-md:  rgba(21, 101, 192, 0.28);
  --orange:         #E64A19;
  --orange-soft:    #FBE9E7;
  --orange-glow:    rgba(230, 74, 25, 0.22);
  --accent:         #0097A7;
  --surface:        #ffffff;
  --surface-2:      #F5F7FA;
  --surface-3:      #EBF1FB;
  --page-bg:        #F0F2F5;
  --border:         #DCE8F8;
  --border-strong:  #BBCFF5;
  --text-primary:   #0C1A2E;
  --text-secondary: #334D6E;
  --text-muted:     #7090B0;
  --success:        #16A34A;
  --success-soft:   #DCFCE7;
  --danger:         #DC2626;
  --danger-soft:    #FFF0F0;
  --font:           'Plus Jakarta Sans', sans-serif;
  --font-serif:     'Lora', serif;
  --ease:           cubic-bezier(0.16, 1, 0.3, 1);
  --radius-sm:      8px;
  --radius-md:      14px;
  --radius-lg:      22px;
  --shadow-sm:      0 1px 3px rgba(0,0,0,0.05), 0 4px 12px rgba(21,101,192,0.06);
  --shadow-md:      0 4px 16px rgba(0,0,0,0.07), 0 12px 32px rgba(21,101,192,0.09);
  --shadow-lg:      0 8px 30px rgba(0,0,0,0.10), 0 24px 56px rgba(21,101,192,0.12);
  --shadow-focus:   0 0 0 3px rgba(21,101,192,0.18);
}

* { box-sizing: border-box; }

body {
  background: var(--page-bg);
  min-height: 100vh;
  font-family: var(--font);
}

/* ======================================
   MAIN SHOP CONTAINER
====================================== */
.shop-editshop {
  display: flex;
  flex-direction: column;
  font-family: var(--font);
  width: 100%;
  max-width: 1300px;
  margin: 24px auto;
  padding: 0 18px 48px;
  background: transparent;
}

/* ======================================
   SUB-NAVBAR
====================================== */
.sub-navbar-editshop {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--surface);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-md);
  padding: 11px 22px;
  margin-bottom: 22px;
  box-shadow: var(--shadow-sm);
  position: relative;
  overflow: hidden;
}

/* Blue left accent — ties to navbar */
.sub-navbar-editshop::before {
  content: '';
  position: absolute;
  left: 0; top: 0; bottom: 0;
  width: 4px;
  background: linear-gradient(180deg, var(--brand) 0%, var(--brand-light) 100%);
  border-radius: var(--radius-md) 0 0 var(--radius-md);
}

.sub_navcomponent-editshop ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  gap: 8px;
}

.sub_navcomponent-editshop ul li a {
  font-family: var(--font);
  font-size: 15px;
  font-weight: 700;
  color: var(--brand);
  text-decoration: none;
  padding: 5px 0;
  border-bottom: 2px solid transparent;
  transition: border-color 0.18s, color 0.18s;
  letter-spacing: -0.1px;
}

.sub_navcomponent-editshop ul li a:hover {
  border-bottom-color: var(--brand-light);
  color: var(--brand-mid);
}

/* Add Item button */
.add-card-button-editshop {
  background: linear-gradient(135deg, var(--orange) 0%, #BF360C 100%);
  color: white;
  border: none;
  padding: 9px 22px;
  border-radius: 100px;
  cursor: pointer;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.2px;
  box-shadow: 0 3px 12px var(--orange-glow);
  transition: transform 0.22s var(--ease), box-shadow 0.22s var(--ease);
  white-space: nowrap;
}

.add-card-button-editshop:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(230, 74, 25, 0.35);
}

/* ======================================
   PRODUCT GRID
====================================== */
.shop_js-editshop {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 18px;
  width: 100%;
}

/* ======================================
   PRODUCT CARD
====================================== */
.shop_card-editshop {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  overflow: hidden;
  box-shadow: var(--shadow-sm);
  transition: transform 0.26s var(--ease), box-shadow 0.26s var(--ease), border-color 0.22s;
  position: relative;
  display: flex;
  flex-direction: column;
  animation: cardFadeIn 0.35s var(--ease) both;
}

@keyframes cardFadeIn {
  from { opacity: 0; transform: translateY(12px) scale(0.98); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
}

/* Blue brand stripe reveals on hover */
.shop_card-editshop::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 3px;
  background: linear-gradient(90deg, var(--brand) 0%, var(--brand-light) 100%);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.26s var(--ease);
  z-index: 1;
}

.shop_card-editshop:hover::before {
  transform: scaleX(1);
}

.shop_card-editshop:hover {
  transform: translateY(-6px);
  box-shadow: var(--shadow-md);
  border-color: var(--border-strong);
}

/* Card image */
.card-image-editshop {
  width: 100%;
  height: 180px;
  object-fit: contain;
  background: linear-gradient(135deg, var(--surface-2) 0%, var(--surface-3) 100%);
  padding: 14px;
  transition: transform 0.32s var(--ease);
  display: block;
  flex-shrink: 0;
}

.shop_card-editshop:hover .card-image-editshop {
  transform: scale(1.05);
}

/* Card content */
.shop_container-editshop {
  padding: 14px 16px 16px;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
  text-align: left !important;
}

/* Product name override */
.shop_container-editshop a[style] {
  font-family: var(--font) !important;
  font-size: 13.5px !important;
  font-weight: 700 !important;
  color: var(--text-primary) !important;
  text-decoration: none !important;
  line-height: 1.3 !important;
  display: block;
  margin-bottom: 2px;
  transition: color 0.15s;
}

.shop_container-editshop a[style]:hover {
  color: var(--brand) !important;
}

/* Card text area */
.card-text-editshop {
  margin: 6px 0 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

/* Description */
.card-text-editshop div[style] {
  font-size: 11px !important;
  color: var(--text-muted) !important;
  font-family: var(--font) !important;
  margin-bottom: 4px !important;
}

/* Price */
.card-text-editshop b[style] {
  font-size: 15px !important;
  font-weight: 800 !important;
  color: var(--text-primary) !important;
  font-family: var(--font) !important;
  letter-spacing: -0.3px;
}

/* Discount badge */
.card-text-editshop span[style*="green"] {
  font-size: 11px !important;
  color: var(--success) !important;
  font-weight: 700 !important;
  padding: 2px 7px !important;
  background: var(--success-soft) !important;
  border-radius: 100px !important;
  display: inline-block !important;
  margin: 0 4px !important;
}

/* MRP strikethrough */
.card-text-editshop span[style*="line-through"] {
  font-size: 11px !important;
  color: var(--text-muted) !important;
  font-family: var(--font) !important;
}

/* Quantity */
.card-text-editshop span:last-of-type {
  font-size: 12px;
  color: var(--text-secondary);
  font-weight: 500;
  margin-top: 4px;
}

/* Card action button row */
.card-actions-editshop {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-top: 10px;
}

/* Edit button */
.edit-btn-editshop {
  width: 100%;
  padding: 9px;
  border: 1.5px solid var(--border-strong);
  border-radius: var(--radius-sm);
  font-family: var(--font);
  font-size: 12.5px;
  font-weight: 700;
  cursor: pointer;
  background: var(--brand-soft);
  color: var(--brand);
  transition: all 0.18s var(--ease);
  letter-spacing: 0.1px;
}

.edit-btn-editshop:hover {
  background: var(--brand);
  color: white;
  border-color: var(--brand);
  transform: translateY(-1px);
}

/* Delete button */
.delete-btn-editshop {
  width: 100%;
  padding: 9px;
  margin-top: 10px;
  border: 1.5px solid #FECACA;
  border-radius: var(--radius-sm);
  font-family: var(--font);
  font-size: 12.5px;
  font-weight: 700;
  cursor: pointer;
  background: var(--danger-soft);
  color: var(--danger);
  transition: all 0.18s var(--ease);
  letter-spacing: 0.1px;
}

.delete-btn-editshop:hover {
  background: var(--danger);
  color: white;
  border-color: var(--danger);
  transform: translateY(-1px);
}

/* Cart button */
.cart-btn-editshop {
  width: 100%;
  padding: 9px;
  margin-top: 8px;
  border: none;
  border-radius: var(--radius-sm);
  font-family: var(--font);
  font-size: 12.5px;
  font-weight: 700;
  cursor: pointer;
  background: linear-gradient(135deg, var(--orange) 0%, #BF360C 100%);
  color: white;
  transition: all 0.18s var(--ease);
  box-shadow: 0 2px 8px var(--orange-glow);
}

.cart-btn-editshop:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 14px var(--orange-glow);
}

/* Wishlist icon */
.wishlist-icon-editshop {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 18px;
  color: var(--text-muted);
  cursor: pointer;
  z-index: 2;
  transition: color 0.18s, transform 0.18s;
}

.wishlist-icon-editshop:hover {
  transform: scale(1.18);
  color: var(--orange);
}

.wishlist-icon-editshop.active {
  color: var(--orange);
}

/* ======================================
   NO ITEMS STATE
====================================== */
.no-items-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 40vh;
  text-align: center;
  color: var(--text-muted);
  gap: 12px;
  padding: 40px 20px;
}

.no-items-message h3 {
  font-family: var(--font);
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--text-secondary);
  margin: 0;
}

.no-items-message p {
  font-size: 14px;
  color: var(--text-muted);
  margin: 0;
}

/* ======================================
   LOADING SPINNER
====================================== */
.loading-spinner-container-editshop {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 240px;
  gap: 16px;
}

.loading-spinner-editshop {
  width: 44px;
  height: 44px;
  border: 4px solid var(--brand-soft);
  border-top: 4px solid var(--brand);
  border-radius: 50%;
  animation: spin 0.85s linear infinite;
}

@keyframes spin {
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-spinner-container-editshop p {
  font-family: var(--font);
  font-size: 14px;
  font-weight: 500;
  color: var(--text-muted);
  margin: 0;
}

/* ======================================
   POPUP TOAST
====================================== */
.popup-message-editshop {
  position: fixed;
  top: 88px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(12, 26, 46, 0.9);
  backdrop-filter: blur(10px);
  color: white;
  padding: 12px 24px;
  border-radius: 100px;
  z-index: 9999;
  font-family: var(--font);
  font-size: 13.5px;
  font-weight: 600;
  box-shadow: var(--shadow-lg);
  white-space: nowrap;
  animation: toastIn 0.25s var(--ease);
}

@keyframes toastIn {
  from { opacity: 0; transform: translateX(-50%) translateY(-10px); }
  to   { opacity: 1; transform: translateX(-50%) translateY(0); }
}

/* ======================================
   MODAL — Add New Item Form
====================================== */
.form-modal-editshop {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(10, 20, 40, 0.5);
  backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.form-content-editshop {
  background: var(--surface);
  border-radius: var(--radius-lg);
  width: 95%;
  max-width: 460px;
  max-height: 92vh;
  display: flex;
  flex-direction: column;
  padding: 0;
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--border-strong);
  animation: modalIn 0.28s var(--ease);
  overflow: hidden;
}

@keyframes modalIn {
  from { opacity: 0; transform: scale(0.95) translateY(18px); }
  to   { opacity: 1; transform: scale(1) translateY(0); }
}

/* Modal top accent */
.form-content-editshop::before {
  content: '';
  display: block;
  height: 4px;
  background: linear-gradient(90deg, var(--brand) 0%, var(--brand-light) 60%, var(--accent) 100%);
  flex-shrink: 0;
}

.form-content-editshop h3 {
  font-family: var(--font);
  font-size: 17px;
  font-weight: 800;
  color: var(--brand);
  margin: 0 0 18px;
  letter-spacing: -0.2px;
}

.form-scroll-container-editshop {
  overflow-y: auto;
  padding: 22px 24px 10px;
  flex-grow: 1;
}

/* Form rows */
.form-row-editshop {
  margin-bottom: 14px;
}

.form-row-editshop label {
  display: block;
  margin-bottom: 5px;
  font-family: var(--font);
  font-size: 11px;
  font-weight: 700;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.7px;
}

.form-row-editshop input[type="text"],
.form-row-editshop input[type="number"] {
  width: 100%;
  padding: 9px 13px;
  border: 1.5px solid var(--border-strong);
  border-radius: var(--radius-sm);
  font-family: var(--font);
  font-size: 13.5px;
  color: var(--text-primary);
  background: var(--surface-2);
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
  box-sizing: border-box;
}

.form-row-editshop input[type="text"]:focus,
.form-row-editshop input[type="number"]:focus {
  border-color: var(--brand-mid);
  box-shadow: var(--shadow-focus);
  background: white;
}

.form-row-editshop input[type="file"] {
  width: 100%;
  padding: 8px 0;
  font-family: var(--font);
  font-size: 12.5px;
  color: var(--text-secondary);
}

.discount-input-readonly {
  background: var(--surface-3) !important;
  color: var(--text-muted) !important;
  cursor: not-allowed !important;
  border-color: var(--border) !important;
}

/* React-Select styling */
.select-wrapper-editshop {
  width: 100%;
}

.select-wrapper-editshop .react-select__control {
  width: 100% !important;
  min-height: 40px !important;
  border: 1.5px solid var(--border-strong) !important;
  border-radius: var(--radius-sm) !important;
  font-family: var(--font) !important;
  font-size: 13.5px !important;
  background: var(--surface-2) !important;
  box-shadow: none !important;
  transition: border-color 0.2s, box-shadow 0.2s !important;
}

.select-wrapper-editshop .react-select__control--is-focused {
  border-color: var(--brand-mid) !important;
  box-shadow: var(--shadow-focus) !important;
  background: white !important;
}

.select-wrapper-editshop .react-select__option--is-selected {
  background: var(--brand) !important;
}

.select-wrapper-editshop .react-select__option--is-focused {
  background: var(--brand-soft) !important;
  color: var(--brand) !important;
}

/* Add category button */
.add-category-button-editshop {
  background: var(--surface-3);
  color: var(--text-secondary);
  border: 1.5px solid var(--border-strong);
  padding: 8px 14px;
  border-radius: var(--radius-sm);
  cursor: pointer;
  font-family: var(--font);
  font-size: 12.5px;
  font-weight: 600;
  margin-bottom: 14px;
  transition: all 0.18s var(--ease);
}

.add-category-button-editshop:hover {
  background: var(--brand-soft);
  border-color: var(--brand-light);
  color: var(--brand);
}

/* Save category input */
.new-category-input-editshop {
  flex: 1 1;
  padding: 8px 12px;
  border: 1.5px solid var(--border-strong);
  border-radius: var(--radius-sm);
  font-family: var(--font);
  font-size: 13px;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.new-category-input-editshop:focus {
  border-color: var(--brand-mid);
  box-shadow: var(--shadow-focus);
}

.save-category-button-editshop {
  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-mid) 100%);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: var(--radius-sm);
  font-family: var(--font);
  font-size: 12.5px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 2px 8px var(--brand-glow);
  transition: transform 0.18s var(--ease), box-shadow 0.18s var(--ease);
  margin-left: 8px;
  white-space: nowrap;
}

.save-category-button-editshop:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 14px var(--brand-glow-md);
}

/* Modal footer actions */
.form-actions-editshop {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 24px 20px;
  border-top: 1px solid var(--border);
  background: var(--surface-2);
  flex-shrink: 0;
}

.form-actions-editshop button:first-child {
  padding: 9px 22px;
  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-mid) 100%);
  color: white;
  border: none;
  border-radius: 100px;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 3px 10px var(--brand-glow);
  transition: transform 0.2s var(--ease), box-shadow 0.2s var(--ease);
}

.form-actions-editshop button:first-child:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 18px var(--brand-glow-md);
}

.form-actions-editshop button:first-child:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.form-actions-editshop button:last-child {
  padding: 9px 18px;
  background: var(--surface);
  color: var(--text-secondary);
  border: 1.5px solid var(--border-strong);
  border-radius: 100px;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.18s var(--ease);
}

.form-actions-editshop button:last-child:hover {
  background: var(--border);
  color: var(--text-primary);
}

/* ======================================
   RESPONSIVE
====================================== */
@media (min-width: 768px) {
  .shop_js-editshop {
    grid-template-columns: repeat(3, 1fr);
    gap: 18px;
  }
}

@media (min-width: 1024px) {
  .shop_js-editshop {
    grid-template-columns: repeat(4, 1fr);
    gap: 22px;
  }
  .card-image-editshop { height: 190px; }
}

@media (max-width: 480px) {
  .shop-editshop { padding: 0 10px 32px; margin: 14px auto; }
  .shop_js-editshop { grid-template-columns: repeat(2, 1fr); gap: 10px; }
  .card-image-editshop { height: 140px; }
  .sub-navbar-editshop { padding: 9px 14px; }
  .add-card-button-editshop { padding: 8px 14px; font-size: 12px; }
  .form-content-editshop { width: 97%; }
  .form-scroll-container-editshop { padding: 16px 16px 8px; }
  .form-actions-editshop { padding: 12px 16px 16px; }
}

@media (max-width: 359px) {
  .shop_js-editshop { grid-template-columns: 1fr; }
}

/* iPhone specific */
@supports (-webkit-touch-callout: none) {
  .shop_js-editshop { grid-template-columns: repeat(2, 1fr); }
  .card-image-editshop { height: 150px; }
}`, "",{"version":3,"sources":["webpack://./src/components/EditShop.css"],"names":[],"mappings":"AAEA;;;;wCAIwC;AACxC;EACE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,0CAA0C;EAC1C,0CAA0C;EAC1C,yBAAyB;EACzB,yBAAyB;EACzB,yCAAyC;EACzC,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,iDAAiD;EACjD,+BAA+B;EAC/B,+CAA+C;EAC/C,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,8EAA8E;EAC9E,gFAAgF;EAChF,gFAAgF;EAChF,iDAAiD;AACnD;;AAEA,IAAI,sBAAsB,EAAE;;AAE5B;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;EAC1B,sCAAsC;EACtC,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO,EAAE,MAAM,EAAE,SAAS;EAC1B,UAAU;EACV,6EAA6E;EAC7E,oDAAoD;AACtD;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,oCAAoC;EACpC,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;EACE,mEAAmE;EACnE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yCAAyC;EACzC,qEAAqE;EACrE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,WAAW;AACb;;AAEA;;wCAEwC;AACxC;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,4BAA4B;EAC5B,yFAAyF;EACzF,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA,uCAAuC;AACvC;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ;EACzB,WAAW;EACX,4EAA4E;EAC5E,oBAAoB;EACpB,sBAAsB;EACtB,uCAAuC;EACvC,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA,eAAe;AACf;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,+EAA+E;EAC/E,aAAa;EACb,uCAAuC;EACvC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,uBAAuB;EACvB,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA,0BAA0B;AAC1B;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,2BAA2B;EAC3B,qCAAqC;EACrC,gCAAgC;EAChC,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,gBAAgB;AAChB;EACE,0BAA0B;EAC1B,mCAAmC;EACnC,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA,UAAU;AACV;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,qCAAqC;EACrC,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,2BAA2B;EAC3B,2BAA2B;EAC3B,0CAA0C;EAC1C,+BAA+B;EAC/B,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;EACE,0BAA0B;EAC1B,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA,aAAa;AACb;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,+BAA+B;EAC/B,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;EAC3B,+BAA+B;EAC/B,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,8BAA8B;EAC9B,oBAAoB;EACpB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,+BAA+B;EAC/B,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mEAAmE;EACnE,YAAY;EACZ,iCAAiC;EACjC,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,SAAS;AACX;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;AACX;;AAEA;;wCAEwC;AACxC;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,iCAAiC;EACjC,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,OAAO,UAAU,EAAE,6CAA6C,EAAE;EAClE,OAAO,UAAU,EAAE,yCAAyC,EAAE;AAChE;;AAEA;;wCAEwC;AACxC;EACE,eAAe;EACf,MAAM,EAAE,OAAO;EACf,WAAW,EAAE,YAAY;EACzB,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,4BAA4B;EAC5B,sCAAsC;EACtC,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,+FAA+F;EAC/F,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA,cAAc;AACd;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,wCAAwC;EACxC,+BAA+B;EAC/B,wBAAwB;EACxB,iBAAiB;EACjB,0BAA0B;EAC1B,4BAA4B;EAC5B,aAAa;EACb,+DAA+D;EAC/D,sBAAsB;AACxB;;AAEA;;EAEE,8BAA8B;EAC9B,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,wBAAwB;EACxB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;EACvC,mCAAmC;EACnC,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA,yBAAyB;AACzB;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,mDAAmD;EACnD,0CAA0C;EAC1C,mCAAmC;EACnC,4BAA4B;EAC5B,uCAAuC;EACvC,2BAA2B;EAC3B,yDAAyD;AAC3D;;AAEA;EACE,yCAAyC;EACzC,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA,wBAAwB;AACxB;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,wCAAwC;EACxC,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,SAAO;EACP,iBAAiB;EACjB,wCAAwC;EACxC,+BAA+B;EAC/B,wBAAwB;EACxB,eAAe;EACf,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,2EAA2E;EAC3E,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,uCAAuC;EACvC,qEAAqE;EACrE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,uBAAuB;EACvB,mCAAmC;EACnC,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,2EAA2E;EAC3E,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,mEAAmE;AACrE;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,4BAA4B;EAC5B,wCAAwC;EACxC,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;wCAEwC;AACxC;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;EACA,uBAAuB,aAAa,EAAE;AACxC;;AAEA;EACE,iBAAiB,oBAAoB,EAAE,iBAAiB,EAAE;EAC1D,oBAAoB,qCAAqC,EAAE,SAAS,EAAE;EACtE,uBAAuB,aAAa,EAAE;EACtC,uBAAuB,iBAAiB,EAAE;EAC1C,4BAA4B,iBAAiB,EAAE,eAAe,EAAE;EAChE,yBAAyB,UAAU,EAAE;EACrC,kCAAkC,sBAAsB,EAAE;EAC1D,yBAAyB,uBAAuB,EAAE;AACpD;;AAEA;EACE,oBAAoB,0BAA0B,EAAE;AAClD;;AAEA,oBAAoB;AACpB;EACE,oBAAoB,qCAAqC,EAAE;EAC3D,uBAAuB,aAAa,EAAE;AACxC","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&family=Lora:ital,wght@0,400;0,600;1,400&display=swap');\n\n/* ======================================\n   DESIGN TOKENS — Pyate Blue Brand\n   Matched to: white navbar, #F0F2F5 page bg,\n   #1565C0 primary blue accents\n====================================== */\n:root {\n  --brand:          #1565C0;\n  --brand-mid:      #1976D2;\n  --brand-light:    #42A5F5;\n  --brand-soft:     #E8F1FB;\n  --brand-glow:     rgba(21, 101, 192, 0.15);\n  --brand-glow-md:  rgba(21, 101, 192, 0.28);\n  --orange:         #E64A19;\n  --orange-soft:    #FBE9E7;\n  --orange-glow:    rgba(230, 74, 25, 0.22);\n  --accent:         #0097A7;\n  --surface:        #ffffff;\n  --surface-2:      #F5F7FA;\n  --surface-3:      #EBF1FB;\n  --page-bg:        #F0F2F5;\n  --border:         #DCE8F8;\n  --border-strong:  #BBCFF5;\n  --text-primary:   #0C1A2E;\n  --text-secondary: #334D6E;\n  --text-muted:     #7090B0;\n  --success:        #16A34A;\n  --success-soft:   #DCFCE7;\n  --danger:         #DC2626;\n  --danger-soft:    #FFF0F0;\n  --font:           'Plus Jakarta Sans', sans-serif;\n  --font-serif:     'Lora', serif;\n  --ease:           cubic-bezier(0.16, 1, 0.3, 1);\n  --radius-sm:      8px;\n  --radius-md:      14px;\n  --radius-lg:      22px;\n  --shadow-sm:      0 1px 3px rgba(0,0,0,0.05), 0 4px 12px rgba(21,101,192,0.06);\n  --shadow-md:      0 4px 16px rgba(0,0,0,0.07), 0 12px 32px rgba(21,101,192,0.09);\n  --shadow-lg:      0 8px 30px rgba(0,0,0,0.10), 0 24px 56px rgba(21,101,192,0.12);\n  --shadow-focus:   0 0 0 3px rgba(21,101,192,0.18);\n}\n\n* { box-sizing: border-box; }\n\nbody {\n  background: var(--page-bg);\n  min-height: 100vh;\n  font-family: var(--font);\n}\n\n/* ======================================\n   MAIN SHOP CONTAINER\n====================================== */\n.shop-editshop {\n  display: flex;\n  flex-direction: column;\n  font-family: var(--font);\n  width: 100%;\n  max-width: 1300px;\n  margin: 24px auto;\n  padding: 0 18px 48px;\n  background: transparent;\n}\n\n/* ======================================\n   SUB-NAVBAR\n====================================== */\n.sub-navbar-editshop {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: var(--surface);\n  border: 1px solid var(--border-strong);\n  border-radius: var(--radius-md);\n  padding: 11px 22px;\n  margin-bottom: 22px;\n  box-shadow: var(--shadow-sm);\n  position: relative;\n  overflow: hidden;\n}\n\n/* Blue left accent — ties to navbar */\n.sub-navbar-editshop::before {\n  content: '';\n  position: absolute;\n  left: 0; top: 0; bottom: 0;\n  width: 4px;\n  background: linear-gradient(180deg, var(--brand) 0%, var(--brand-light) 100%);\n  border-radius: var(--radius-md) 0 0 var(--radius-md);\n}\n\n.sub_navcomponent-editshop ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  gap: 8px;\n}\n\n.sub_navcomponent-editshop ul li a {\n  font-family: var(--font);\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--brand);\n  text-decoration: none;\n  padding: 5px 0;\n  border-bottom: 2px solid transparent;\n  transition: border-color 0.18s, color 0.18s;\n  letter-spacing: -0.1px;\n}\n\n.sub_navcomponent-editshop ul li a:hover {\n  border-bottom-color: var(--brand-light);\n  color: var(--brand-mid);\n}\n\n/* Add Item button */\n.add-card-button-editshop {\n  background: linear-gradient(135deg, var(--orange) 0%, #BF360C 100%);\n  color: white;\n  border: none;\n  padding: 9px 22px;\n  border-radius: 100px;\n  cursor: pointer;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.2px;\n  box-shadow: 0 3px 12px var(--orange-glow);\n  transition: transform 0.22s var(--ease), box-shadow 0.22s var(--ease);\n  white-space: nowrap;\n}\n\n.add-card-button-editshop:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(230, 74, 25, 0.35);\n}\n\n/* ======================================\n   PRODUCT GRID\n====================================== */\n.shop_js-editshop {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 18px;\n  width: 100%;\n}\n\n/* ======================================\n   PRODUCT CARD\n====================================== */\n.shop_card-editshop {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  overflow: hidden;\n  box-shadow: var(--shadow-sm);\n  transition: transform 0.26s var(--ease), box-shadow 0.26s var(--ease), border-color 0.22s;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  animation: cardFadeIn 0.35s var(--ease) both;\n}\n\n@keyframes cardFadeIn {\n  from { opacity: 0; transform: translateY(12px) scale(0.98); }\n  to   { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n/* Blue brand stripe reveals on hover */\n.shop_card-editshop::before {\n  content: '';\n  position: absolute;\n  top: 0; left: 0; right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, var(--brand) 0%, var(--brand-light) 100%);\n  transform: scaleX(0);\n  transform-origin: left;\n  transition: transform 0.26s var(--ease);\n  z-index: 1;\n}\n\n.shop_card-editshop:hover::before {\n  transform: scaleX(1);\n}\n\n.shop_card-editshop:hover {\n  transform: translateY(-6px);\n  box-shadow: var(--shadow-md);\n  border-color: var(--border-strong);\n}\n\n/* Card image */\n.card-image-editshop {\n  width: 100%;\n  height: 180px;\n  object-fit: contain;\n  background: linear-gradient(135deg, var(--surface-2) 0%, var(--surface-3) 100%);\n  padding: 14px;\n  transition: transform 0.32s var(--ease);\n  display: block;\n  flex-shrink: 0;\n}\n\n.shop_card-editshop:hover .card-image-editshop {\n  transform: scale(1.05);\n}\n\n/* Card content */\n.shop_container-editshop {\n  padding: 14px 16px 16px;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  text-align: left !important;\n}\n\n/* Product name override */\n.shop_container-editshop a[style] {\n  font-family: var(--font) !important;\n  font-size: 13.5px !important;\n  font-weight: 700 !important;\n  color: var(--text-primary) !important;\n  text-decoration: none !important;\n  line-height: 1.3 !important;\n  display: block;\n  margin-bottom: 2px;\n  transition: color 0.15s;\n}\n\n.shop_container-editshop a[style]:hover {\n  color: var(--brand) !important;\n}\n\n/* Card text area */\n.card-text-editshop {\n  margin: 6px 0 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n/* Description */\n.card-text-editshop div[style] {\n  font-size: 11px !important;\n  color: var(--text-muted) !important;\n  font-family: var(--font) !important;\n  margin-bottom: 4px !important;\n}\n\n/* Price */\n.card-text-editshop b[style] {\n  font-size: 15px !important;\n  font-weight: 800 !important;\n  color: var(--text-primary) !important;\n  font-family: var(--font) !important;\n  letter-spacing: -0.3px;\n}\n\n/* Discount badge */\n.card-text-editshop span[style*=\"green\"] {\n  font-size: 11px !important;\n  color: var(--success) !important;\n  font-weight: 700 !important;\n  padding: 2px 7px !important;\n  background: var(--success-soft) !important;\n  border-radius: 100px !important;\n  display: inline-block !important;\n  margin: 0 4px !important;\n}\n\n/* MRP strikethrough */\n.card-text-editshop span[style*=\"line-through\"] {\n  font-size: 11px !important;\n  color: var(--text-muted) !important;\n  font-family: var(--font) !important;\n}\n\n/* Quantity */\n.card-text-editshop span:last-of-type {\n  font-size: 12px;\n  color: var(--text-secondary);\n  font-weight: 500;\n  margin-top: 4px;\n}\n\n/* Card action button row */\n.card-actions-editshop {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n/* Edit button */\n.edit-btn-editshop {\n  width: 100%;\n  padding: 9px;\n  border: 1.5px solid var(--border-strong);\n  border-radius: var(--radius-sm);\n  font-family: var(--font);\n  font-size: 12.5px;\n  font-weight: 700;\n  cursor: pointer;\n  background: var(--brand-soft);\n  color: var(--brand);\n  transition: all 0.18s var(--ease);\n  letter-spacing: 0.1px;\n}\n\n.edit-btn-editshop:hover {\n  background: var(--brand);\n  color: white;\n  border-color: var(--brand);\n  transform: translateY(-1px);\n}\n\n/* Delete button */\n.delete-btn-editshop {\n  width: 100%;\n  padding: 9px;\n  margin-top: 10px;\n  border: 1.5px solid #FECACA;\n  border-radius: var(--radius-sm);\n  font-family: var(--font);\n  font-size: 12.5px;\n  font-weight: 700;\n  cursor: pointer;\n  background: var(--danger-soft);\n  color: var(--danger);\n  transition: all 0.18s var(--ease);\n  letter-spacing: 0.1px;\n}\n\n.delete-btn-editshop:hover {\n  background: var(--danger);\n  color: white;\n  border-color: var(--danger);\n  transform: translateY(-1px);\n}\n\n/* Cart button */\n.cart-btn-editshop {\n  width: 100%;\n  padding: 9px;\n  margin-top: 8px;\n  border: none;\n  border-radius: var(--radius-sm);\n  font-family: var(--font);\n  font-size: 12.5px;\n  font-weight: 700;\n  cursor: pointer;\n  background: linear-gradient(135deg, var(--orange) 0%, #BF360C 100%);\n  color: white;\n  transition: all 0.18s var(--ease);\n  box-shadow: 0 2px 8px var(--orange-glow);\n}\n\n.cart-btn-editshop:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 14px var(--orange-glow);\n}\n\n/* Wishlist icon */\n.wishlist-icon-editshop {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 18px;\n  color: var(--text-muted);\n  cursor: pointer;\n  z-index: 2;\n  transition: color 0.18s, transform 0.18s;\n}\n\n.wishlist-icon-editshop:hover {\n  transform: scale(1.18);\n  color: var(--orange);\n}\n\n.wishlist-icon-editshop.active {\n  color: var(--orange);\n}\n\n/* ======================================\n   NO ITEMS STATE\n====================================== */\n.no-items-message {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 40vh;\n  text-align: center;\n  color: var(--text-muted);\n  gap: 12px;\n  padding: 40px 20px;\n}\n\n.no-items-message h3 {\n  font-family: var(--font);\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: var(--text-secondary);\n  margin: 0;\n}\n\n.no-items-message p {\n  font-size: 14px;\n  color: var(--text-muted);\n  margin: 0;\n}\n\n/* ======================================\n   LOADING SPINNER\n====================================== */\n.loading-spinner-container-editshop {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 240px;\n  gap: 16px;\n}\n\n.loading-spinner-editshop {\n  width: 44px;\n  height: 44px;\n  border: 4px solid var(--brand-soft);\n  border-top: 4px solid var(--brand);\n  border-radius: 50%;\n  animation: spin 0.85s linear infinite;\n}\n\n@keyframes spin {\n  0%   { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.loading-spinner-container-editshop p {\n  font-family: var(--font);\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-muted);\n  margin: 0;\n}\n\n/* ======================================\n   POPUP TOAST\n====================================== */\n.popup-message-editshop {\n  position: fixed;\n  top: 88px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(12, 26, 46, 0.9);\n  backdrop-filter: blur(10px);\n  color: white;\n  padding: 12px 24px;\n  border-radius: 100px;\n  z-index: 9999;\n  font-family: var(--font);\n  font-size: 13.5px;\n  font-weight: 600;\n  box-shadow: var(--shadow-lg);\n  white-space: nowrap;\n  animation: toastIn 0.25s var(--ease);\n}\n\n@keyframes toastIn {\n  from { opacity: 0; transform: translateX(-50%) translateY(-10px); }\n  to   { opacity: 1; transform: translateX(-50%) translateY(0); }\n}\n\n/* ======================================\n   MODAL — Add New Item Form\n====================================== */\n.form-modal-editshop {\n  position: fixed;\n  top: 0; left: 0;\n  width: 100%; height: 100%;\n  background: rgba(10, 20, 40, 0.5);\n  backdrop-filter: blur(8px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.form-content-editshop {\n  background: var(--surface);\n  border-radius: var(--radius-lg);\n  width: 95%;\n  max-width: 460px;\n  max-height: 92vh;\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n  box-shadow: var(--shadow-lg);\n  border: 1px solid var(--border-strong);\n  animation: modalIn 0.28s var(--ease);\n  overflow: hidden;\n}\n\n@keyframes modalIn {\n  from { opacity: 0; transform: scale(0.95) translateY(18px); }\n  to   { opacity: 1; transform: scale(1) translateY(0); }\n}\n\n/* Modal top accent */\n.form-content-editshop::before {\n  content: '';\n  display: block;\n  height: 4px;\n  background: linear-gradient(90deg, var(--brand) 0%, var(--brand-light) 60%, var(--accent) 100%);\n  flex-shrink: 0;\n}\n\n.form-content-editshop h3 {\n  font-family: var(--font);\n  font-size: 17px;\n  font-weight: 800;\n  color: var(--brand);\n  margin: 0 0 18px;\n  letter-spacing: -0.2px;\n}\n\n.form-scroll-container-editshop {\n  overflow-y: auto;\n  padding: 22px 24px 10px;\n  flex-grow: 1;\n}\n\n/* Form rows */\n.form-row-editshop {\n  margin-bottom: 14px;\n}\n\n.form-row-editshop label {\n  display: block;\n  margin-bottom: 5px;\n  font-family: var(--font);\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.7px;\n}\n\n.form-row-editshop input[type=\"text\"],\n.form-row-editshop input[type=\"number\"] {\n  width: 100%;\n  padding: 9px 13px;\n  border: 1.5px solid var(--border-strong);\n  border-radius: var(--radius-sm);\n  font-family: var(--font);\n  font-size: 13.5px;\n  color: var(--text-primary);\n  background: var(--surface-2);\n  outline: none;\n  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;\n  box-sizing: border-box;\n}\n\n.form-row-editshop input[type=\"text\"]:focus,\n.form-row-editshop input[type=\"number\"]:focus {\n  border-color: var(--brand-mid);\n  box-shadow: var(--shadow-focus);\n  background: white;\n}\n\n.form-row-editshop input[type=\"file\"] {\n  width: 100%;\n  padding: 8px 0;\n  font-family: var(--font);\n  font-size: 12.5px;\n  color: var(--text-secondary);\n}\n\n.discount-input-readonly {\n  background: var(--surface-3) !important;\n  color: var(--text-muted) !important;\n  cursor: not-allowed !important;\n  border-color: var(--border) !important;\n}\n\n/* React-Select styling */\n.select-wrapper-editshop {\n  width: 100%;\n}\n\n.select-wrapper-editshop .react-select__control {\n  width: 100% !important;\n  min-height: 40px !important;\n  border: 1.5px solid var(--border-strong) !important;\n  border-radius: var(--radius-sm) !important;\n  font-family: var(--font) !important;\n  font-size: 13.5px !important;\n  background: var(--surface-2) !important;\n  box-shadow: none !important;\n  transition: border-color 0.2s, box-shadow 0.2s !important;\n}\n\n.select-wrapper-editshop .react-select__control--is-focused {\n  border-color: var(--brand-mid) !important;\n  box-shadow: var(--shadow-focus) !important;\n  background: white !important;\n}\n\n.select-wrapper-editshop .react-select__option--is-selected {\n  background: var(--brand) !important;\n}\n\n.select-wrapper-editshop .react-select__option--is-focused {\n  background: var(--brand-soft) !important;\n  color: var(--brand) !important;\n}\n\n/* Add category button */\n.add-category-button-editshop {\n  background: var(--surface-3);\n  color: var(--text-secondary);\n  border: 1.5px solid var(--border-strong);\n  padding: 8px 14px;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  font-family: var(--font);\n  font-size: 12.5px;\n  font-weight: 600;\n  margin-bottom: 14px;\n  transition: all 0.18s var(--ease);\n}\n\n.add-category-button-editshop:hover {\n  background: var(--brand-soft);\n  border-color: var(--brand-light);\n  color: var(--brand);\n}\n\n/* Save category input */\n.new-category-input-editshop {\n  flex: 1;\n  padding: 8px 12px;\n  border: 1.5px solid var(--border-strong);\n  border-radius: var(--radius-sm);\n  font-family: var(--font);\n  font-size: 13px;\n  outline: none;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.new-category-input-editshop:focus {\n  border-color: var(--brand-mid);\n  box-shadow: var(--shadow-focus);\n}\n\n.save-category-button-editshop {\n  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-mid) 100%);\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: var(--radius-sm);\n  font-family: var(--font);\n  font-size: 12.5px;\n  font-weight: 700;\n  cursor: pointer;\n  box-shadow: 0 2px 8px var(--brand-glow);\n  transition: transform 0.18s var(--ease), box-shadow 0.18s var(--ease);\n  margin-left: 8px;\n  white-space: nowrap;\n}\n\n.save-category-button-editshop:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 14px var(--brand-glow-md);\n}\n\n/* Modal footer actions */\n.form-actions-editshop {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 14px 24px 20px;\n  border-top: 1px solid var(--border);\n  background: var(--surface-2);\n  flex-shrink: 0;\n}\n\n.form-actions-editshop button:first-child {\n  padding: 9px 22px;\n  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-mid) 100%);\n  color: white;\n  border: none;\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  box-shadow: 0 3px 10px var(--brand-glow);\n  transition: transform 0.2s var(--ease), box-shadow 0.2s var(--ease);\n}\n\n.form-actions-editshop button:first-child:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 18px var(--brand-glow-md);\n}\n\n.form-actions-editshop button:first-child:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.form-actions-editshop button:last-child {\n  padding: 9px 18px;\n  background: var(--surface);\n  color: var(--text-secondary);\n  border: 1.5px solid var(--border-strong);\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.18s var(--ease);\n}\n\n.form-actions-editshop button:last-child:hover {\n  background: var(--border);\n  color: var(--text-primary);\n}\n\n/* ======================================\n   RESPONSIVE\n====================================== */\n@media (min-width: 768px) {\n  .shop_js-editshop {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 18px;\n  }\n}\n\n@media (min-width: 1024px) {\n  .shop_js-editshop {\n    grid-template-columns: repeat(4, 1fr);\n    gap: 22px;\n  }\n  .card-image-editshop { height: 190px; }\n}\n\n@media (max-width: 480px) {\n  .shop-editshop { padding: 0 10px 32px; margin: 14px auto; }\n  .shop_js-editshop { grid-template-columns: repeat(2, 1fr); gap: 10px; }\n  .card-image-editshop { height: 140px; }\n  .sub-navbar-editshop { padding: 9px 14px; }\n  .add-card-button-editshop { padding: 8px 14px; font-size: 12px; }\n  .form-content-editshop { width: 97%; }\n  .form-scroll-container-editshop { padding: 16px 16px 8px; }\n  .form-actions-editshop { padding: 12px 16px 16px; }\n}\n\n@media (max-width: 359px) {\n  .shop_js-editshop { grid-template-columns: 1fr; }\n}\n\n/* iPhone specific */\n@supports (-webkit-touch-callout: none) {\n  .shop_js-editshop { grid-template-columns: repeat(2, 1fr); }\n  .card-image-editshop { height: 150px; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
